import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router'
import axios from 'axios'
import { EMPRESAS_PERMISOS_BOTONES } from '@/settings/permisoBotones'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    usuario: null,
    emp: {},
    permisos_botones: [],
    permisos_botones_cargados: false
  },
  getters: {
    puedeBoton: (state) => (pantalla, boton) => {
      if (!state.emp || !EMPRESAS_PERMISOS_BOTONES.includes(Number(state.emp.id_empresa))) {
        return true;
      }

      if (!state.permisos_botones_cargados) {
        return false;
      }
      const p = state.permisos_botones.find((x) => x.pantalla == pantalla);

      if (!p) {
        return true;
      }
      return p[boton] === true || p[boton] === 1 || p[boton] === "1";
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setEmpresa(state, empresa) {
      state.emp = empresa;
    },
    setPermisosBotones(state, permisos) {
      state.permisos_botones = Array.isArray(permisos) ? permisos : [];
      state.permisos_botones_cargados = true;
    }
  },
  actions: {
    guardarToken({ commit }, token) {
      localStorage.setItem("token", token);
      commit("setToken", token);
      commit("setUsuario", decode(token));

      router.push({ name: "bienvenido" }).catch(() => { });
    },
    autoLogin({ commit }) {
      let token = localStorage.getItem("token");
      if (token) {
        commit("setToken", token);
        commit("setUsuario", decode(token));
      } else {
        router.push({ name: "login" }).catch(() => { });
      }
    },
    guardarEmpresa({ commit, dispatch }, emp) {
      commit("setEmpresa", emp);
      dispatch("cargarPermisosBotones");
    },
    cargarPermisosBotones({ commit, state }) {
      const emp = state.emp;
      const usuario = state.usuario;
      if (!emp || !usuario || !EMPRESAS_PERMISOS_BOTONES.includes(Number(emp.id_empresa))) {
        commit("setPermisosBotones", []);
        return;
      }
      return axios
        .get("api/PermisosBotones/Listar/" + usuario.idUsuario + "/" + emp.id_empresa)
        .then((response) => {
          commit("setPermisosBotones", response.data || []);
        })
        .catch((error) => {
          console.error("ERROR AL CARGAR PERMISOS DE BOTONES:", error);
          commit("setPermisosBotones", []);
        });
    },
    salir({ commit }) {
      commit("setToken", null);
      commit("setUsuario", null);
      commit("setEmpresa", {});
      commit("setPermisosBotones", []);
      localStorage.removeItem("token");
      router.push({ name: "login" }).catch(() => { });
    }
  },
})
